import './AdminAudit.scss'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import moment from 'moment'
import { Modal, Pagination, Progress, Spin, Table, notification } from 'antd'
import { getAuditPromise } from './promises'
import { AdminAuditFilters } from './components'
import { ReportService } from '../../services'
import { exportMovimientosPromise } from './promises'
import { UploadProgressService } from '../../services'

class AdminAudit extends Component {
  initialFiltersState = {
    filtersDate: 'ALL',
    filtersDateFrom: '',
    filtersDateTo: '',
    filtersUser: '',
    filtersAction: ''
  }

  state = {
    isLoading: true,
    isLoadingReport: false,
    exporting: false,
    exportProgress: 0,
    exportError: null,
    exportStage: null, // null = no exportando, 1 = extrayendo, 2 = generando, 'downloading' = descargando
    filtersDate: this.initialFiltersState.filtersDate,
    filtersDateFrom: this.initialFiltersState.filtersDateFrom,
    filtersDateTo: this.initialFiltersState.filtersDateTo,
    filtersUser: this.initialFiltersState.filtersUser,
    filtersAction: this.initialFiltersState.filtersAction,
    results: [],
    currentPage: 1,
    fromNum: 0,
    resultsPerPage: 10,
    resultsTotalNum: -1
  }

  async componentDidMount() {
    this.getFirstSearchResults()
  }

  componentWillUnmount() {
    if (this.progressService) {
      try { this.progressService.close() } catch (e) { /* ignore */ }
      this.progressService = null
    }
  }

  getFilters() {
    const filters = {}

    for (let key in this.initialFiltersState) {
      let value = this.state[key]
      if (key === 'filtersDate') {
        filters['optDates'] = value
        if (value === 'RANGE') {
          filters['fromDate'] = this.state['filtersDateFrom']
          filters['toDate'] = this.state['filtersDateTo']
        }
      }

      if (key === 'filtersUser') {
        filters['userId'] = value
      }

      if (key === 'filtersAction') {
        filters['type'] = value
      }
    }
    return filters
  }

  async getFirstSearchResults() {
    this.handlePaginationOnChange(1)
  }

  async handlePaginationOnChange(currentPage) {
    const { resultsPerPage } = this.state
    const fromNum = ((currentPage - 1) * resultsPerPage)

    await this.setState({ isLoading: true, fromNum: fromNum })

    const searchResults = await getAuditPromise(fromNum, resultsPerPage, this.getFilters())

    await this.setState({
      isLoading: false,
      results: searchResults.records,
      currentPage: currentPage,
      resultsTotalNum: searchResults.total
    })
  }

  renderTableColumns() {
    const { t } = this.props

    const tableColumns = [
      {
        title: t('messages.aml.date'),
        dataIndex: 'dateShortAsString',
        className: 'nowrap'
      },
      {
        title: t('messages.aml.username'),
        dataIndex: 'userName',
        className: 'nowrap'
      },
      {
        title: t('messages.aml.type'),
        dataIndex: 'type',
        render: (text) => t('messages.aml.action.' + text)
      },
      {
        title: t('messages.aml.detail'),
        dataIndex: 'subType'
      },
      {
        title: t('messages.aml.parameters'),
        dataIndex: 'params',
        className: 'params-cell',
        render: text => <div>{ text }</div>
      }
    ]

    return tableColumns
  }

  async onExportHandler() {
    if (this.progressService) {
      try { this.progressService.close() } catch (e) { /* ignore */ }
      this.progressService = null
    }

    await this.setState({
      exporting: true,
      exportProgress: 0,
      exportError: null,
      isLoadingReport: true,
      exportStage: null
    })

    try {
      const response = await exportMovimientosPromise(this.getFilters())
      if (response && response.batchId) {
        this.listenExportProgress(response.batchId)
      } else {
        await this.setState({ exportError: 'No se pudo iniciar la exportación', isLoadingReport: false })
      }
    } catch (e) {
      await this.setState({ exportError: 'No se pudo iniciar la exportación', isLoadingReport: false })
    }
  }

  handleCancelExport() {
    if (this.progressService) {
      try { this.progressService.close() } catch (e) { /* ignore */ }
      this.progressService = null
    }
    this.setState({
      exporting: false,
      exportProgress: 0,
      exportError: null,
      isLoadingReport: false,
      exportStage: null
    })
  }

  handleExportConnectionError(message) {
    if (this.progressService) {
      try { this.progressService.close() } catch (e) { /* ignore */ }
      this.progressService = null
    }
    this.setState({
      exportError: message || 'Error de conexión en progreso',
      exporting: false,
      isLoadingReport: false,
      exportStage: null
    })
  }

  listenExportProgress(batchId) {
    const { t } = this.props
    this.progressService = UploadProgressService.listenProgress(
        batchId,
        { onProgress: (progressData) => {
            const value = progressData.progress || 0
            const stage = progressData.stage
            this.setState((prev) => {
              const nextProgress = (prev.exportStage !== stage && stage === 2) ? 0 : value
              const changed =
                prev.exportProgress !== nextProgress ||
                prev.exportStage !== stage ||
                prev.exportError !== null
              return changed ? { exportProgress: nextProgress, exportError: null, exportStage: stage } : null
            })

            if (progressData.status === 'ERROR') {
              this.handleExportConnectionError(progressData.message || 'Error al exportar movimientos')
              return
            }
          },
          onComplete: async () => {
            const fileName = 'movimientos.xlsx'
            this.setState({ exportStage: 'downloading', exportProgress: 100 })
            try {
              await ReportService.read('/inputFile', { path: "reportes/movimientos/" + batchId + ".xlsx", remove: true }, null, fileName, null, t)
            } finally {
              this.setState({
                exporting: false,
                exportProgress: 0,
                exportError: null,
                exportStage: null,
                isLoadingReport: false
              })
            }
          },
          onInactivity: () => {
            notification.warning({
              message: t('messages.aml.warning'),
              description: t('messages.aml.downloadInactivity'),
            });
          },
          onError: (error) => {
            const descriptionText =error ?  t(error) : t('messages.aml.anErrorOcurredWhileUploadingFile');
            this.handleExportConnectionError(descriptionText)
          }
        }
    );
  }

  handleOnChangeDate(filtersDate) {
    this.setState({ filtersDate })
  }

  handleOnChangeDateFrom(filtersDateFrom) {
    this.setState({ filtersDateFrom: moment(filtersDateFrom).format('DD/MM/YYYY') })
  }

  handleOnChangeDateTo(filtersDateTo) {
    this.setState({ filtersDateTo: moment(filtersDateTo).format('DD/MM/YYYY') })
  }

  handleOnChangeUser(filtersUser) {
    this.setState({ filtersUser })
  }

  handleOnChangeAction(filtersAction) {
    this.setState({ filtersAction })
  }

  handleOnClickRestoreFilters() {
    this.setState({
      filtersDate: this.initialFiltersState.filtersDate,
      filtersDateFrom: this.initialFiltersState.filtersDateFrom,
      filtersDateTo: this.initialFiltersState.filtersDateTo,
      filtersUser: this.initialFiltersState.filtersUser,
      filtersAction: this.initialFiltersState.filtersAction,
      currentPage: 1,
      fromNum: 0,
      resultsPerPage: 10,
      resultsTotalNum: -1
    })
    this.getFirstSearchResults()
  }

  render() {
    const {
      isLoading,
      isLoadingReport,
      filtersDate,
      filtersDateFrom,
      filtersDateTo,
      filtersUser,
      filtersAction,
      results,
      currentPage,
      resultsTotalNum,
      resultsPerPage,
      exporting,
      exportProgress,
      exportError,
      exportStage
    } = this.state

    const { t } = this.props

    return (
      <div className="admin-audit">
        <Modal
          visible={exporting || !!exportError}
          footer={null}
          onCancel={this.handleCancelExport.bind(this)}
          maskClosable={false}
        >
          {exportError ? (
            <div>
              <p style={{color: 'red'}}>{exportError}</p>
            </div>
          ) : (
            <div>
              <p>
                {exportStage === 'downloading'
                  ? t('messages.aml.downloadingFile') 
                  : exportStage === 1 
                      ? t('messages.aml.extractingData')
                      : exportStage === 2 
                          ? t('messages.aml.generatingReport')
                          : t('messages.aml.exporting') + '...'}
              </p>
              <Progress percent={Math.round(exportProgress)} />
              { exportStage === 'downloading' &&
                <center style={{padding:10}}><Spin spinning={true}/></center>
              }
            </div>
          )}
        </Modal>
        <AdminAuditFilters
          defaultValues={{ filtersDate, filtersDateFrom, filtersDateTo, filtersUser, filtersAction }}
          onChangeDateHandler={ this.handleOnChangeDate.bind(this) }
          onChangeDateFromHandler={ this.handleOnChangeDateFrom.bind(this) }
          onChangeDateToHandler={ this.handleOnChangeDateTo.bind(this) }
          onChangeUserHandler={ this.handleOnChangeUser.bind(this) }
          onChangeActionHandler={ this.handleOnChangeAction.bind(this) }
          onClickRestoreFiltersHandler={ this.handleOnClickRestoreFilters.bind(this) }
          onClickExportHandler={ this.onExportHandler.bind(this) }
          onSubmit={ this.getFirstSearchResults.bind(this) }
          />
          <div className="table-wrapper">
            { isLoading ?
              <Spin spinning={ true } size="large" />
              :
              <Table dataSource={ results } columns={ this.renderTableColumns() } pagination={ false } loading={ isLoadingReport } size="small" />
            }
          </div>
          <Pagination
            current={ currentPage } 
            total={ resultsTotalNum } 
            onChange={ this.handlePaginationOnChange.bind(this) } 
            pageSize={ resultsPerPage } 
            size="small"
            showTotal={(total, range) => `${range[0]}-${range[1]} ${t('messages.aml.of')} ${total} ${t('messages.aml.entries')}`}
          />
      </div>
    )
  }
}

export default withTranslation()(AdminAudit)
